var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserCheck = function SvgUserCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#0376C9",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Asset"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8898 6.58504C10.8898 8.38109 9.42434 9.83709 7.61672 9.83709C5.80909 9.83709 4.34372 8.38109 4.34372 6.58504C4.34372 4.78899 5.80909 3.33301 7.61672 3.33301C9.42434 3.33301 10.8898 4.78899 10.8898 6.58504ZM1.6665 16.3412C1.6665 13.6484 4.33727 11.4631 7.61682 11.4631C10.8963 11.4631 13.5672 13.6484 13.5672 16.3412C13.5672 16.5233 13.4231 16.6663 13.2398 16.6663H1.9938C1.81051 16.6663 1.6665 16.5233 1.6665 16.3412ZM18.0908 8.50559C18.4136 8.18016 18.4136 7.65252 18.0908 7.32708C17.7681 7.00165 17.2448 7.00165 16.9221 7.32708L14.7517 9.51559L13.9587 8.71601C13.6359 8.39051 13.1127 8.39051 12.7899 8.71601C12.4672 9.04142 12.4672 9.56901 12.7899 9.89451L14.1673 11.2833C14.49 11.6088 15.0133 11.6088 15.3361 11.2833L18.0908 8.50559Z"
  }))));
};
export default SvgUserCheck;